import {useDispatch, useSelector} from "react-redux";
import {setFavouritesIsActive} from "../../../../Features/Misc/navBarSlice"
import stripHtml from "../../../Components/StripHTML";
import { Animate } from "react-simple-animate";
import Footer from "../../../Components/Footer";
import RecommendedBox from "../../../structure/Recommended/RecommendedBox";
import BackButton from "../../../Components/BackButton";
import FaveHeart from "../../../Components/FaveHeart";
import VideoModal from "../../../Components/VideoModal";
import {activeMediaReset} from "../../../../Features/Misc/activeSlice";



import defaultSleepImage1 from "../../../../assets/default-images/default-sleep-image-1.png"
import defaultSleepImage2 from '../../../../assets/default-images/default-sleep-image-2.png';
import defaultSleepImage3 from '../../../../assets/default-images/default-sleep-image-3.png';
import defaultSleepImage4 from '../../../../assets/default-images/default-sleep-image-4.png';
import defaultSleepImage6 from '../../../../assets/default-images/default-sleep-image-6.jpg';
import defaultSleepImage7 from '../../../../assets/default-images/default-sleep-image-7.jpg';
import defaultSleepImage8 from '../../../../assets/default-images/default-sleep-image-8.jpg';
import defaultSleepImage9 from '../../../../assets/default-images/default-sleep-image-9.jpg';
import defaultSleepImage10 from '../../../../assets/default-images/default-sleep-image-10.jpg';

export default function FaveLearnOffCanvas(props) {

    const dispatch = useDispatch()

    const { activeLearn } = useSelector((state) => state.active)
    const { imgSrc, text, title, vidLink, mediaId, mediaType, orientation } = activeLearn && activeLearn

    // console.log(activeLearn && activeLearn)

    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10,
    ];

    const randomImgNumber = Math.floor(Math.random() * 9);

    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];


    return (

        <div className={`h-full overflow-y-auto flex flex-col gap-4 `}>
            <Animate play start={{opacity: 0}} end={{opacity: 1, display: "flex", flexDirection: "column", gap: "1rem" }} duration={0.7} >
            <BackButton customStyles={false} func={() => { dispatch(setFavouritesIsActive()); dispatch(activeMediaReset()) } } />

            <div className=" learn__offCanvas flex flex-col gap-4 px-4 pt-2 mb-8 sm:mb-0" >
                <div className="learn__offCanvas__faveBar  flex flex-col sm:flex-row justify-between sm:px-4 py-1 ">
                    <div className={`text-white text-xl`}>{stripHtml(title)}</div>
                    <FaveHeart type={"Learn_offCanvas"} mediaId={mediaId} mediaType={mediaType} />
                </div>

                <div className="learn__offCanvas__inner__img h-72 mb-4 rounded-xl bg-cover no-repeat bg-center "
                     style={{backgroundImage: `url(${imageUrl})`}}>
                    <VideoModal vidLink={vidLink} orientation={orientation}/>
                </div>

                <div className="learn_offCanvas__inner__textbox bg-white rounded-lg pt-4 ">


                    <div dangerouslySetInnerHTML={{__html: text}} className='watch__offCanvas__inner__textbox__content  px-4 pb-4 text-sm  '>

                    </div>

                    <div className="bg-gold-accent rounded-b-lg h-2"></div>
                </div>

            </div>
            <div className="sm:hidden px-4">
                <RecommendedBox />
            </div>

            <Footer className={`sm:hidden text-sm text-white pt-4 flex justify-center items-center`} />
            </Animate>
        </div>

    );
}
